export const SELECTED_BANK = 'SELECTED_BANK'
export const PSD2_FLOW_TYPE = 'PSD2_FLOW_TYPE'